import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import { useEffect } from 'react';
import { BeKindSection } from '../../components/block-be-kind';
import { InstagramFeed } from '../../components/homepageComponents';
import { Layout } from '../../components/layout';
import { styled } from '../../styles/stitches.config';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import ProcessSection from '../../components/our-story/process-section';
import FounderSection from '../../components/our-story/founder-section';
import { Seo } from '../../components/seo';
import HeaderSection from '../../components/our-story/header-section';

const OurStory = () => {
    useEffect(() => {
        document.getElementsByTagName('body')[0].style.overflow = "auto";
    }, []);
    const QuoteSection = styled('section', {
        padding: '80px 80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: '$cardo',
        h1: {
            fontSize: '36px',
            textAlign: 'center',
            maxWidth: '640px',
            fontWeight: 400,
            fontStyle: 'italic',
        },
    });

    return (
        <Layout>
            <Seo
                title={'Our Story - Better Days Skin Co.'}
            />
            <HeaderSection />
            <QuoteSection>
                <h1>Better Days&apos; goal is to make things simple, so that everyone can experience the freedom of being comfortable and confident in their own skin.</h1>
            </QuoteSection>
            <FounderSection />
            <ProcessSection />
            <BeKindSection />
            <InstagramFeed />
        </Layout >
    )
}

export default OurStory;
